export default function SvgBasicPin(props) {
    return (
        <svg {...props} viewBox="0 0 62 81" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M61.0429 30.8578C61.2053 58.1977 31.2658 80.9109 31.2658 80.9109C31.2658 80.9109 1.01108 59.6598 0.842177 31.2153C0.741819 14.3143 14.1525 0.481407 30.7334 0.38295C47.3144 0.284493 60.9426 13.9568 61.0429 30.8578Z"
                fill="black"/>
        </svg>
    )
}